import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { IoCalendarNumberOutline } from "react-icons/io5";
import { ListPanel } from "./ListPanel";
import { VscCalendar } from "react-icons/vsc";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: VscCalendar,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ListPanel: ListPanel,
    createConfig:  {
        group: 'Functions',
        name: "Calendar",
        description: "Calendar",
        panel: OverviewPanel,
    },
}